import React, { useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';
import useClickOutside from '../../../hooks/useClickOutside';
import Portal from '../../ui/Portal';
import styles from './UserModal.module.css';
import form from '../../../styles/shared/FormDialog.module.css';
import dialog from '../../../styles/shared/Dialog.module.css';

// Crear / editar usuario. Estilos comunes en styles/shared/FormDialog.module.css (como el de talleres):
// etiquetas visibles, campos de 48px y Cancelar | acción principal abajo.
const UserModal = ({ isOpen, onClose, onSubmit, formValues, handleInputChange, isEditMode, error }) => {
  const modalRef = useRef(null);

  useClickOutside(modalRef, onClose, isOpen);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = isEditMode ? 'Editar usuario' : 'Crear usuario';

  return (
    <Portal>
      <div className={form.overlay}>
        <div
          className={form.content}
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-labelledby="user-modal-title"
        >
          <div className={form.header}>
            <h2 id="user-modal-title" className={form.formTitle}>{title}</h2>
            <button type="button" className={form.close} onClick={onClose} aria-label="Cerrar">
              <MdClose aria-hidden="true" />
            </button>
          </div>
          <form onSubmit={onSubmit} className={form.form}>
            <div className={form.field}>
              <label htmlFor="user-nombre" className={form.label}>Nombre</label>
              <input
                id="user-nombre"
                type="text"
                name="nombre"
                className={form.formInput}
                placeholder="Nombre y apellido"
                autoComplete="name"
                value={formValues.nombre}
                onChange={handleInputChange}
              />
            </div>
            <div className={form.field}>
              <label htmlFor="user-email" className={form.label}>Correo</label>
              <input
                id="user-email"
                type="email"
                name="email"
                className={form.formInput}
                placeholder="nombre@duoc.cl"
                autoComplete="email"
                aria-describedby="user-email-hint"
                value={formValues.email}
                onChange={handleInputChange}
              />
              <p id="user-email-hint" className={form.hint}>Debe terminar en @duoc.cl o @profesor.duoc.cl</p>
            </div>
            <div className={form.field}>
              <label htmlFor="user-password" className={form.label}>Contraseña</label>
              <input
                id="user-password"
                type="password"
                name="password"
                className={form.formInput}
                autoComplete="new-password"
                aria-describedby={isEditMode ? 'user-password-hint' : undefined}
                value={formValues.password}
                onChange={handleInputChange}
              />
              {isEditMode && (
                <p id="user-password-hint" className={form.hint}>Déjala vacía para mantener la contraseña actual</p>
              )}
            </div>
            <div className={styles.toggles}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="isStaff"
                  className={styles.checkbox}
                  checked={formValues.isStaff}
                  onChange={handleInputChange}
                />
                Administrador
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="estado"
                  className={styles.checkbox}
                  checked={formValues.estado}
                  onChange={handleInputChange}
                />
                Activo
              </label>
            </div>
            {error && <p className={form.formError} role="alert">{error}</p>}
            <div className={`${dialog.buttons} ${form.buttons}`}>
              <button type="button" className={dialog.cancelButton} onClick={onClose}>Cancelar</button>
              <button type="submit" className={dialog.confirmButton}>
                {isEditMode ? 'Guardar cambios' : 'Crear usuario'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Portal>
  );
};

export default UserModal;
